import { render } from "./akEmpty.vue?vue&type=template&id=0aa71544&scoped=true"
import script from "./akEmpty.vue?vue&type=script&lang=js"
export * from "./akEmpty.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0aa71544"

export default script